import { useEffect, useState } from "react";
import { HeaderComponent } from "../Config/header";
import { FooterComponent } from "../Config/footer";
import { API_BASE_URL } from "../Config/Config";
import { Link, useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Spin } from "antd";
import TextArea from "antd/es/input/TextArea";
import Swal from "sweetalert2";

const Maps = () => {
  const navigate = useNavigate();
  const [punchType, setPunchType] = useState("");
  const [address, setAddress] = useState("");
  const [storedUserData, setStoredUserData] = useState([]);
  const [profileDetails, setProfileDetails] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [textNotes, setTextNotes] = useState("");
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [punchLoading, setPunchLoading] = useState(false);
  const [punchTypeLoading, setPunchTypeLoading] = useState(false);
  const handleNotesChange = (e) => {
    setTextNotes(e.target.value);
  };
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
  });

  useEffect(() => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    const superId =
      localStorage.getItem("superId") || sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found");
      navigate("/");
    }
  }, [navigate]);

  const formattedTime = currentTime.toLocaleTimeString();

  const percentage = 100;
  const strokeColor = punchType === "Out" ? "#007bff" : "#28a745";

  const googleMapsURL = `https://www.google.com/maps?q=${location.latitude},${location.longitude}&hl=en&z=14&output=embed`;

  useEffect(() => {
    const fetchGeolocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
          },
          (error) => {
            console.error("Error getting geolocation:", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    };

    fetchGeolocation();

    const intervalId = setInterval(fetchGeolocation, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchAddress = async () => {
      if (location.latitude && location.longitude) {
        try {
          setLoadingAddress(true);

          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${location.latitude}&lon=${location.longitude}`
          );

          const data = await res.json();
          setAddress(data.display_name || "Address not found");
        } catch (err) {
          console.error("Error fetching address:", err);
        } finally {
          setLoadingAddress(false);
        }
      }
    };

    fetchAddress();
  }, [location]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      try {
        const parsedUserDetails = JSON.parse(userDataString);
        setStoredUserData(parsedUserDetails);
      } catch (error) {
        console.error("Error parsing userDetails:", error);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchData = async () => {
      if (!storedUserData?.RegId) {
        console.error("RegId is not available");
        return;
      }
      if (!location.latitude || !location.longitude) {
        console.error("Location is not available");
        // Swal.fire({
        //   title: "Location Required",
        //   text: "Please enable location services to continue.",
        //   icon: "warning",
        //   confirmButtonText: "Ok",
        // });
        console.error("Location is not available");
        return;
      }

      try {
        setPunchTypeLoading(true);

        const profileResponse = await fetch(
          `${API_BASE_URL}emp/getempprofile?regid=${storedUserData.RegId}`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${tokenData}` },
          }
        );
        if (!profileResponse.ok) {
          throw new Error("Profile request failed");
        }
        const profileData = await profileResponse.json();
        setProfileDetails(profileData?.ResultData[0]);

        const punchTypeUrl = `${API_BASE_URL}attendance/getNextPunchType?regid=${storedUserData.RegId}`;
        const punchTypeResponse = await fetch(punchTypeUrl, {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        });
        if (!punchTypeResponse.ok) {
          throw new Error("PunchType request failed");
        }
        const punchTypeData = await punchTypeResponse.json();
        setPunchType(punchTypeData.ResultData.PunchType);
      } catch (error) {
        console.error("Error in fetching data:", error.message);
      } finally {
        setPunchTypeLoading(false);
      }
    };
    fetchData();
  }, [storedUserData, location]);

  const handleButtonPunchClick = async () => {
    if (!location.latitude || !location.longitude) {
      Swal.fire({
        icon: "error",
        title: "Location Required",
        text: "Please enable location services to punch in.",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      setPunchLoading(true);

      const url = `${API_BASE_URL}attendance/writeswipewithLocation`;

      const date = new Date();
      const formattedDateTime =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0") +
        " " +
        String(date.getHours()).padStart(2, "0") +
        ":" +
        String(date.getMinutes()).padStart(2, "0") +
        ":" +
        String(date.getSeconds()).padStart(2, "0");

      const inPunchData = {
        superid: storedUserData.SuperId,
        cardid: profileDetails?.CardId,
        regid: storedUserData.RegId,
        dateoftransaction: formattedDateTime,
        Latitude: location.latitude,
        Longitude: location.longitude,
        notes: textNotes,
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenData}`,
        },
        body: JSON.stringify(inPunchData),
      });

      if (!response.ok) {
        throw new Error(`POST request failed with status ${response.status}`);
      }

      const responseData = await response.json();
      if (responseData.status == true) {
        Swal.fire({
          icon: "success",
          title: "Punch Successful",
          text: "Your punch-in was recorded successfully!",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Punch Failed",
          text: responseData.Message,
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      Swal.fire({
        icon: "error",
        title: "Punch Failed",
        text:
          error.message || "An unexpected error occurred while punching in.",
        confirmButtonText: "Try Again",
      });
    } finally {
      setPunchLoading(false);
    }
  };

  return (
    <>
      {punchLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <HeaderComponent></HeaderComponent>
      <div style={{ position: "relative", width: "100%" }}>
        {/* Iframe */}
        <iframe
          title="Google Map"
          width="100%"
          height="50%" // Adjust height as needed
          frameBorder="0"
          style={{ border: 0 }}
          src={googleMapsURL}
          allowFullScreen
        ></iframe>

        {/* Transparent overlay to disable clicks */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "transparent",
            zIndex: 1,
          }}
        ></div>
      </div>
      <div className="d-flex mx-1 justify-content-center">
        <h6 className="text-gray-600 text-bold col-8">
          {loadingAddress
            ? "Address: loading..."
            : address
            ? `Address: ${address}`
            : "Address: N/A"}
        </h6>
        <div className="d-flex align-items-center ms-2 ms-lg-1 mx-5">
          <a
            className="btn btn-flex flex-center btn-primary align-self-center px-0 px-md-3 h-30px w-30px w-md-auto h-lg-40px ms-1 ms-lg-2" // Reduced ms-2 to ms-1 and ms-lg-4 to ms-lg-2
            onClick={() => window.location.reload()}
          >
            <i className="fa-solid fa-arrows-rotate"></i>
          </a>
        </div>
      </div>
      <div className="card m-3">
        <div className="card-body p-3">
          <div className="d-flex justify-content-around align-items-center row">
            <div className="col-7">
              <TextArea
                rows={3}
                placeholder="Notes"
                value={textNotes} // Bind the state
                onChange={handleNotesChange} // Update state on change
                className="w-100"
              />
            </div>
            {punchTypeLoading ? (
              <div
                className="col-3 d-flex align-items-center "
                style={{
                  width: "auto",
                }}
              >
                <Spin />
              </div>
            ) : (
              <div
                onClick={location ? handleButtonPunchClick : null}
                className="col-1 d-flex align-items-center "
                style={{
                  position: "relative",
                  width: "35%",
                  aspectRatio: "1 / 1",
                }}
              >
                {/* Circular Progress Bar */}
                <CircularProgressbar
                  value={percentage}
                  strokeWidth={5}
                  styles={{
                    path: { stroke: strokeColor }, // Set stroke color dynamically
                    trail: { stroke: "#d6d6d6" }, // Trail color
                  }}
                />

                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    fill={strokeColor}
                    width="40px"
                    height="40px"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#ffffff"
                  >
                    <path d="M390.42,75.28a10.45,10.45,0,0,1-5.32-1.44C340.72,50.08,302.35,40,256.35,40c-45.77,0-89.23,11.28-128.76,33.84C122,77,115.11,74.8,111.87,69a12.4,12.4,0,0,1,4.63-16.32A281.81,281.81,0,0,1,256.35,16c49.23,0,92.23,11.28,139.39,36.48a12,12,0,0,1,4.85,16.08A11.3,11.3,0,0,1,390.42,75.28Zm-330.79,126a11.73,11.73,0,0,1-6.7-2.16,12.26,12.26,0,0,1-2.78-16.8c22.89-33.6,52-60,86.69-78.48C209.42,65,302.35,64.72,375.16,103.6c34.68,18.48,63.8,44.64,86.69,78a12.29,12.29,0,0,1-2.78,16.8,11.26,11.26,0,0,1-16.18-2.88c-20.8-30.24-47.15-54-78.36-70.56-66.34-35.28-151.18-35.28-217.29.24-31.44,16.8-57.79,40.8-78.59,71A10,10,0,0,1,59.63,201.28ZM204.1,491a10.66,10.66,0,0,1-8.09-3.6C175.9,466.48,165,453,149.55,424c-16-29.52-24.27-65.52-24.27-104.16,0-71.28,58.71-129.36,130.84-129.36S387,248.56,387,319.84a11.56,11.56,0,1,1-23.11,0c0-58.08-48.32-105.36-107.72-105.36S148.4,261.76,148.4,319.84c0,34.56,7.39,66.48,21.49,92.4,14.8,27.6,25,39.36,42.77,58.08a12.67,12.67,0,0,1,0,17A12.44,12.44,0,0,1,204.1,491Zm165.75-44.4c-27.51,0-51.78-7.2-71.66-21.36a129.1,129.1,0,0,1-55-105.36,11.57,11.57,0,1,1,23.12,0,104.28,104.28,0,0,0,44.84,85.44c16.41,11.52,35.6,17,58.72,17a147.41,147.41,0,0,0,24-2.4c6.24-1.2,12.25,3.12,13.4,9.84a11.92,11.92,0,0,1-9.47,13.92A152.28,152.28,0,0,1,369.85,446.56ZM323.38,496a13,13,0,0,1-3-.48c-36.76-10.56-60.8-24.72-86-50.4-32.37-33.36-50.16-77.76-50.16-125.28,0-38.88,31.9-70.56,71.19-70.56s71.2,31.68,71.2,70.56c0,25.68,21.5,46.56,48.08,46.56s48.08-20.88,48.08-46.56c0-90.48-75.13-163.92-167.59-163.92-65.65,0-125.75,37.92-152.79,96.72-9,19.44-13.64,42.24-13.64,67.2,0,18.72,1.61,48.24,15.48,86.64,2.32,6.24-.69,13.2-6.7,15.36a11.34,11.34,0,0,1-14.79-7,276.39,276.39,0,0,1-16.88-95c0-28.8,5.32-55,15.72-77.76,30.75-67,98.94-110.4,173.6-110.4,105.18,0,190.71,84.24,190.71,187.92,0,38.88-31.9,70.56-71.2,70.56s-71.2-31.68-71.2-70.56C303.5,293.92,282,273,255.42,273s-48.08,20.88-48.08,46.56c0,41,15.26,79.44,43.23,108.24,22,22.56,43,35,75.59,44.4,6.24,1.68,9.71,8.4,8.09,14.64A11.39,11.39,0,0,1,323.38,496Z" />
                  </svg>
                  <div className="row text-center mt-2">
                    <div className="fw-bold">
                      {punchType === "In" ? "Punch In" : "Punch Out"}
                    </div>
                    <div className="text-gray-600">{formattedTime}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <FooterComponent></FooterComponent>
    </>
  );
};

export default Maps;
